import React, { Component, cloneElement } from 'react';
import { List, CreateButton, RefreshButton, TopToolbar, Datagrid, TextField, DateField, ShowButton, Filter, TextInput, SelectInput, DateInput } from 'react-admin';
// import { DateInput } from 'react-admin-date-inputs';
import { Scrollbars } from 'react-custom-scrollbars';
import Spinner from '../spinner';
import myDataProvider from '../myRestProvider';
import { unparse as convertToCSV } from 'papaparse/papaparse.min';
import Modal from 'react-responsive-modal';

const selectInputStyle = {
    width: 200,
};

const SoAppFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Title" source="title"/>
        <TextInput label="Purpose" source="purpose"/>
        <TextInput label="Admin Email" source="admin_email" />
        <TextInput label="Admin Name" source="admin_name" />
        <SelectInput source="job_status" choices={[
            { id: 'Complete', name: 'Complete' },
            { id: 'Queued', name: 'Queued' },
            { id: 'Working', name: 'Working' },
        ]}
        />
        <SelectInput style={selectInputStyle} source="type" choices={[
            { id: 'Country', name: 'All Sales Officer' },
            { id: 'SalesOfficer', name: 'A set of Sales Officer' },
        ]}
        />
        <DateInput source="uploaded_date_from"  
        // label="Uploaded date from" 
         />
        <DateInput source="uploaded_date_to" 
        //  label="Uploaded date to"  
         />
    </Filter>
);

// const topToolbarStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };

const textFieldStyle = {
    display: 'block',
    width: 200,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',

};

const ListActions = ({ resource, basePath, filterValues, total, maxResults, currentSort, exporter, permanentFilter, showFilter, displayedFilters, filters }) => {
    return (
        <TopToolbar>
            {filters && cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button',
            })}
            <CreateButton basePath={basePath} />
            <RefreshButton />
        </TopToolbar>
    )
}

class SoAppNotificationList extends Component {
    state = {
        modalShow: false,
    }
    exporter = (data) => {
        const msg = data[0].message;
        this.setState({
            modalShow: true,
            modalMsg: msg,
        })
    }

    onClose = () => {
        this.setState({
            modalShow: false,
        })
    }

    render() {
        const { state, props, permissions } = this;
        return (
            <React.Fragment>
                <Scrollbars className="scroll-container" >
                    <List {...props} exporter={this.exporter} sort={{ field: 'created_at', order: 'DESC' }}  filters={<SoAppFilter />} title="Notification" bulkActionButtons={false} actions={<ListActions permissions={permissions} />}>
                        <Datagrid rowClick="show">
                            <TextField label="Purpose" source="purpose" style={textFieldStyle} allowEmpty />
                            <TextField label="Title" source="title" style={textFieldStyle} allowEmpty />
                            <TextField label="Type" source="type" sortable={false} allowEmpty />
                            <TextField label="Notification Progress" source="job_status" />
                            <TextField label="Creator Name" source="admin_name" />
                            <TextField label="Creator Email" source="admin_email" />
                            {/* <DateField label={'Created at'} source="created_at" allowEmpty /> */}
                            <DateField 
                            // label="Created At" 
                            source="created_at" showTime />
                            <ShowButton />
                        </Datagrid>
                    </List>
                </Scrollbars>
                {
                    state.modalShow &&
                    <Modal open={state.modalShow} onClose={this.onClose} center>
                        <h3>{state.modalMsg}</h3>
                    </Modal>
                }
            </React.Fragment>
        )
    }
}

export default SoAppNotificationList;